import { combineReducers } from 'redux';
import { APIReducer } from 'store/apiReducer';

import {
    CONTEXT_CREER_EMPLOYE_METIER_ASSO,
    CONTEXT_GET_EMPLOYES_LISTE,
    CONTEXT_MODIFIER_EMPLOYE,
    CONTEXT_REINITIALISER_MOT_DE_PASSE_EMPLOYE,
    CONTEXT_SUPPRIMER_EMPLOYE,
} from '../../constants/apiUrls.constants';

const gestionEmployes = combineReducers({
    employesManagementStore: APIReducer.bind(null, CONTEXT_GET_EMPLOYES_LISTE),
    supprimerEmployeStore: APIReducer.bind(null, CONTEXT_SUPPRIMER_EMPLOYE),
    creerEmploye: APIReducer.bind(null, CONTEXT_CREER_EMPLOYE_METIER_ASSO),
    modifierEmploye: APIReducer.bind(null, CONTEXT_MODIFIER_EMPLOYE),
    reinitialiserMotDePasseEmploye: APIReducer.bind(
        null,
        CONTEXT_REINITIALISER_MOT_DE_PASSE_EMPLOYE,
    ),
});

export default gestionEmployes;
